import React from 'react';
import './Command.css';
import PowerButton from './PowerButton.jsx';
import Volume from './Volume.jsx';
import Soundbank from './Soundbank.jsx'

export default function Command (props){
    
    return (
        <div className="command">
            <div className="controls">
                <div class="controls-title">Controls</div>
                <PowerButton goFull={props.goFull} handlePower ={props.handlePower} powerBtn = {props.powerBtn} />
                <Volume handleVolume = {props.handleVolume} volume={props.volume}/>
                <Soundbank handleBank = {props.handleBank}/>
            </div>
            <div className="display">
                <div className="current-note"> 
                  <div>{props.powerBtn ? "Current Note:" : ""}</div>
                  <div className="current-note-char">{props.powerBtn ? props.currentNote : ""}</div> 
                </div>
                <div className="current-bank">
                    <div>{props.powerBtn ? "Current Bank:" : ""}</div>
                    <div className= "current-bank-string">{props.powerBtn ? props.currentBank : ""}</div>
                </div>
            </div>
        </div>
        
    )
}